module.exports = __webpack_public_path__ + "static/media/FATF-guidance-banking.a698a236.pdf";